module.exports = __webpack_public_path__ + "img/skv_tretch_craventail_0.634a5ab6.png";